/***
**Module Name: Signup 
 **File Name :  Signup.js
 **Project :    Dadi
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  Kiran Kumar
 **author :  Mani Kanta
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 27 2022
 **Last modified on: Dec 27 2022
 **Description : contains Signup details.
 ***/
import React, { useState, useEffect } from "react";
import { Row, Col, CardBody, Card, Container, Input, Label, Form } from "reactstrap";
// import "../../src/assets/css/style.css";
import SweetAlert from 'react-bootstrap-sweetalert';
import tmdbApi from "../api/tmdbApi";
import { Link, useNavigate } from "react-router-dom";
import { getSuggestedQuery } from "@testing-library/react";
import axios from 'axios';
import * as Config from "../constants/Config";
import SessionPopup from "../pages/SessionPopup";
import logo from '../assets/images/Dadi-logo.svg';
import signinImage from "../assets/images/signing-img.svg";

let { lambda, appname } = window.app;


const CreatePassword = () => {



  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
  let id = params.id;



  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [passwordError, setPasswordErr] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [number, setNumber] = useState(false);
  const [upper, setUpper] = useState(false);
  const [limit, setLimit] = useState(false);
  const [lower, setLower] = useState(false);
  const [special, setSpecial] = useState(false);
  const [success, setSuccess] = useState(false);
  const [BtnLoader, setBtnLoader] = useState(false);
  const [error, setError] = useState('');
  const [image, setImg] = useState('');
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [visibility, setVisibility] = useState({ newpwd: false, cnfrmpwd: false });
  const [passwordInput, setPasswordInput] = useState({
    password: '',
    confirmPassword: ''
  })

  useEffect(() => {
    getuser();
  }, []);

  useEffect(() => {

    if (window.site === undefined) {
      setTimeout(() => {
        if (window.site && window.site.common && window.site.common.imagesCDN) {
          setImg(window.site.common.imagesCDN)
        }
      }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imagesCDN) {
      setImg(window.site.common.imagesCDN)
    }

  }, [window.site]);

  const getuser = (e) => {
    axios({
      method: 'GET',
      url: lambda + '/userInfo?appname=' + appname + '&userid=' + id,
    })
      .then(function (response) {

        if (response?.data?.result == "Invalid token or Expired") {
          setShowSessionPopupup(true)
        } else {
          console.log("response", response?.data?.result?.[0]?.emailid);
          setEmail(response?.data?.result?.[0]?.emailid)
          setUserDetails(response?.data?.result?.[0])
        }

      });
  }


  const checkInput = (e) => {
    const onlyDigits = e.target.value.replace(/\D/g, "");
    setNumber(onlyDigits);

  };

  const handlePasswordChange = (evnt) => {
    const passwordInputValue = evnt.target.value.trim();
    const passwordInputFieldName = evnt.target.name;
    const NewPasswordInput = { ...passwordInput, [passwordInputFieldName]: passwordInputValue }
    setPasswordInput(NewPasswordInput);

  }
  const handleAddclass = (evnt) => {
    var element = document.getElementById("instruction");
    element.classList.add("ins-dsp-none");
  }
  const handleRemoveclass = (evnt) => {
    var element = document.getElementById("instruction");
    element.classList.remove("ins-dsp-none");
  }

  const handleValidation = (evnt) => {
    const passwordInputValue = evnt.target.value.trim();
    const passwordInputFieldName = evnt.target.name;
    setConfirmPasswordError("")
    //for password 
    if (passwordInputFieldName === 'password') {
      const uppercaseRegExp = /(?=.*?[A-Z])/;
      const lowercaseRegExp = /(?=.*?[a-z])/;
      const digitsRegExp = /(?=.*?[0-9])/;
      const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
      const minLengthRegExp = /.{8,}/;
      const passwordLength = passwordInputValue.length;
      const uppercasePassword = uppercaseRegExp.test(passwordInputValue);
      const lowercasePassword = lowercaseRegExp.test(passwordInputValue);
      const digitsPassword = digitsRegExp.test(passwordInputValue);
      const specialCharPassword = specialCharRegExp.test(passwordInputValue);
      const minLengthPassword = minLengthRegExp.test(passwordInputValue);
      let errMsg = "";
      if (passwordLength === 0) {
        errMsg = "Password is empty";
      }
      // else if (!uppercasePassword) {
      //   errMsg = "At least one Uppercase";
      // } else if (!lowercasePassword) {
      //   errMsg = "At least one Lowercase";
      // } else if (!digitsPassword) {
      //   errMsg = "At least one digit";
      // } else if (!specialCharPassword) {
      //   errMsg = "At least one Special Characters";
      // } else if (!minLengthPassword) {
      //   errMsg = "At least minumum 8 characters";
      // } else {
      //   errMsg = "";
      // }
      if (uppercasePassword) {
        var element = document.getElementById("err1");
        element.classList.add("vaild");
        setUpper(true);
      } else {
        var element = document.getElementById("err1");
        element.classList.remove("vaild");
        setUpper(false);
      }
      if (lowercasePassword) {
        var element = document.getElementById("err");
        element.classList.add("vaild");
        setLower(true);
      } else {
        var element = document.getElementById("err");
        element.classList.remove("vaild");
        setLower(false);
      }
      if (digitsPassword) {
        var element = document.getElementById("err2");
        element.classList.add("vaild");
        setNumber(true);
      } else {
        var element = document.getElementById("err2");
        element.classList.remove("vaild");
        setNumber(false);
      }
      if (specialCharPassword) {
        var element = document.getElementById("err3");
        element.classList.add("vaild");
        setSpecial(true)
      } else {
        var element = document.getElementById("err3");
        element.classList.remove("vaild");
        setSpecial(false)
      }
      if (minLengthPassword) {
        var element = document.getElementById("err4");
        element.classList.add("vaild");
        setLimit(true)
      } else {
        var element = document.getElementById("err4");
        element.classList.remove("vaild");
        setLimit(false)
      }
      if (limit && upper && special && lower && number && confirmPasswordError === "") {
        setError("")
      }

      setPasswordErr(errMsg);
    }
    // for confirm password

  }
  const togglePassword = (e) => {
    setPasswordShown(!passwordShown);
  };
  const handleCreate = (e) => {

    if (passwordInput?.password == "") {
      setError("Please Enter Password");
      setTimeout(function () { setError("") }, 3000);

    } else if (passwordInput?.confirmPassword == "") {
      setError("Please Enter Confirm Password");
      setTimeout(function () { setError("") }, 3000);

    } else if (passwordInput?.confirmPassword && (passwordInput?.confirmPassword !== passwordInput?.password)) {
      setConfirmPasswordError("Confirm password is not matched");
    }

    else if (!limit || !upper || !special || !lower || !number) {

      setError("Please enter the password as per the instructions");
      // setTimeout(function () { setError("") }, 3000);

    }

    else if (limit && upper && special && lower && number && confirmPasswordError === "") {
      setError("")
      if (passwordInput?.password == passwordInput?.confirmPassword) {
        setConfirmPasswordError("")
        createpwd();
      }
    }
    // else {
    //   createpwd();
    // }

  }

  const createpwd = async () => {
    setBtnLoader(true)
    try {
      let userid = userDetails?.userid
      let userType = userDetails?.userType
      const response = await tmdbApi.CreatePassword(userid, userType, {
        "emailid": email,
        "password": passwordInput?.password
      });
      console.log(response);
      if (response?.statusCode == 200) {
        setSuccess(true);
      }
      setBtnLoader(false)
    } catch {
      setBtnLoader(false)
      console.log("error");
    }
  };
  function onConfirm() {
    // navigate("/");
    window.location.href = "/"
  };

  function handleBack() {
    // navigate("/");
    window.location.href = "/"
  };



  return (
    <>

      <div className="signin-wrapper" id="signin-wrapper">
        <div className="logo_section" id="logo-section">
          <img
            src={`${logo}`}
            className="logo"
            id="signin-logo"
          />
          <button className="close-btn" onClick={handleBack} id="signin-close-btn">
            <span className="material-icons">close</span>
          </button>
        </div>
        <div className="signin-body" id="signin-body">
          <div className="signin-graphic" id="signin-graphic">
            <img
              src={signinImage}
              id="signin-graphic-img"
            />
            <h3 id="onboarding-title">Seamless Onboarding</h3>
            <p id="onboarding-subtitle">Successful Beginnings: Your Journey Starts Here!</p>
          </div>

          <div className="signin-section generate-password-wrapper">
            <h1 className="bold-heading" id="defaultHeading">Create Password</h1>
            <p id="defaultInstruction">Create Strong and Secure to Keep your account Safe</p>

            <div className="input_group_wrapper">
              <label className="form_label d-flex">Email</label>
              <div className="input_group">
                <div className="icon_wrapper">
                  <span className="material-symbols-outlined">mail</span>
                </div>
                <input type="text" className="form-control" id="email-input" value={email} placeholder="Enter your email" disabled />
              </div>
            </div>


            <div className="input_group_wrapper mt-4">
              <label className="form_label">New Password</label>
              <div className="input_group">
                <div className="icon_wrapper">
                  <span className="material-symbols-outlined">lock</span>
                </div>
                <input type={visibility?.newpwd ? "text" : "password"} value={passwordInput?.password} onChange={(e) => handlePasswordChange(e)} onKeyUp={handleValidation} onBlur={(e) => { handleAddclass(e) }} onFocus={(e) => { handleRemoveclass(e) }} name="password" className="form-control padding-right" id="new-password-input" placeholder="New Password" />


                <span className="material-symbols-outlined lock-style" onClick={() => setVisibility((prev) => ({ ...prev, newpwd: !prev.newpwd }))}>{visibility.newpwd ? "visibility_off" : "visibility"}</span>
              </div>
              <span className="errormsg" id="password-error">{passwordError}</span>
            </div>

            <div className="input_group_wrapper mt-4">
              <label className="form_label">Confirm Password</label>
              <div className="input_group">
                <div className="icon_wrapper">
                  <span className="material-symbols-outlined">lock</span>
                </div>

                <input type={visibility?.cnfrmpwd ? "text" : "password"} value={passwordInput?.confirmPassword} onChange={(e) => handlePasswordChange(e)} onKeyUp={handleValidation} onBlur={(e) => { handleAddclass(e) }} onFocus={(e) => { handleRemoveclass(e) }} name="confirmPassword" className="form-control padding-right" id="confirm-password-input" placeholder="Confirm Password" />

                <span onClick={() => setVisibility((prev) => ({ ...prev, cnfrmpwd: !prev.cnfrmpwd }))} id="toggle-confirm-password-visibility" className="material-symbols-outlined lock-style">{visibility.cnfrmpwd ? "visibility_off" : "visibility"}</span>
              </div>
              <span className="errormsg" id="general-error" >
                {error}
              </span>
              <span className="errormsg" id="confirm-password-error">{confirmPasswordError}</span>
            </div>


            <div className="signin-footer mt-3">
              <button className="fill-btn create-quiz-btn border-0" onClick={handleCreate}>

                Create Password
              </button>

            </div>
          </div>


          <div className="create-password-error">
            <div className="create-password-instruction ins-dsp-none" id="instruction">
              <div className="callouts-left">
                <p className="error" id="err" data-testid="lowercase-error">{lower ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain a lower case letter</p>
                <p className="error" id="err1" data-testid="uppercase-error">{upper ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain an upper case letter</p>
                <p className="error" id="err2" data-testid="number-error">{number ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain a number</p>
                <p className="error" id="err4" data-testid="special-character-error">{special ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain a special character or a space</p>
                <p className="error" id="err3" data-testid="length-error">{limit ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain at least 8 characters</p>
              </div>
            </div>
          </div>


        </div>

      </div>

      <footer className="login_footer">
        <div className="container-fluid">
          <p className="footer-para" id="footer-text"> © {new Date().getFullYear()} Dermatopathology Society of India. All rights reserved.</p>
        </div>
      </footer>



      <SweetAlert show={success}
        custom
        confirmBtnText="Back to Login"
        confirmBtnBsStyle="primary"
        title={"Password set successfully"}
        onConfirm={e => onConfirm()}
      >
      </SweetAlert>
    </>
  );
};

export default CreatePassword;